import {
  put,
  select,
  takeLatest,
  call,
  take,
  fork,
  all,
} from 'redux-saga/effects';
import _ from 'lodash';
import moment from 'moment';
import uuidv4 from 'uuid/v4';
import { goto } from '../../../actions/historyActions';
import { showErrorModal } from '../../../actions/uiActions';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import {
  // getOffersFeatures,
  getOffersFormSubmitApiApi,
  getIsPromotionChecked,
} from '../selectors/offersSelector';
import { getToken } from '../../../selectors/authSelectors';
import {
  COMMIT_OFFERS_FORM,
  updateOffersFormResponse,
  SUBMIT_OFFERS_LEAD_FORM,
  updateReviewLoading,
  submitOffersLeadForm,
  // FETCH_OFFERS_FEATURES,
} from '../actions/offersFormAction';
import { putCustState, fetchCustState } from '../../../actions/userActions';
import { updateOffersForm } from '../actions/offersFormAction';
import { t } from '../../../locales';
import { FRAME_APP_MOUNTED } from '../../../actions/frameActions';
import {
  // FETCH_OFFERS_FEATURES_SUCCESS,
  // FETCH_OFFERS_FEATURES_FAILURE,
  UPDATE_PROMOTION_ERROR_CODE,
} from '../../../modules/offers/actions/offersFormAction';
import { filterBanner } from '../../../modules/emma-axa-promotional-offer/sagas/promoSaga';
// import { getOffersFeatureUrl } from '../../../modules/offers/selectors/offersSelector';
import { getCustomerProfileCustKey } from '../../../modules/emma-customer-profile/selectors/customerProfileSelectors';
import { getLanguage } from '../../../selectors/userSelectors';
import {
  OFFER_SUBMITTED_FORM_CUST_KEY,
  PROMOTION_ERROR_CODE,
} from '../constants';
import { store } from '../../../stores';

function* toCommitOffers(action: any) {
  try {
    const url = yield select(getOffersFormSubmitApiApi);
    const token = select(getToken);
    const { submitOffersData } = action;
    if (token) {
      let isNotOfferComfirm = false;
      let customStateObj: any = {};
      const resCustomtState = yield fetchCustState(
        OFFER_SUBMITTED_FORM_CUST_KEY,
        'emma',
      );
      if (resCustomtState !== '') {
        customStateObj = JSON.parse(decodeURI(resCustomtState));
        isNotOfferComfirm =
          customStateObj && customStateObj.sportsPaOfferForm === 1;
      }
      if (isNotOfferComfirm) {
        yield put(
          updateOffersFormResponse({
            title: 'OFFERS_COMFIRM_UNSUCCESS_TITLE',
            msg: 'OFFERS_COMFIRM_UNSUCCESS_MSG',
            buttonText: 'OFFERS_COMFIRM_SUCCESS_BUTTON_TEXT',
          }),
        );
        goto(`emma-free-offers-success`);
      } else {
        const res = yield call(
          myAxaFetchWithToken,
          url,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(submitOffersData),
          },
          undefined,
          undefined,
          0,
        );
        if (res && res.status === 200) {
          // form reset to originally state
          const offersData = {
            infoObj: {
              name: '',
              gender: '',
              birthday: '',
              email: '',
              mobileCountryCode: '852',
              mobile: '',
              consultantMobileCountryCode: '852',
              consultantMobile: '',
              product: '',
              promotionCode: '',
              agentCode: '',
            },
            dependentArr: [],
          };
          yield updateOffersForm(offersData);
          // setup SubmittedForm
          const custValue = JSON.stringify({
            ...customStateObj,
            sportsPaOfferForm: 1,
          });
          yield putCustState(OFFER_SUBMITTED_FORM_CUST_KEY, custValue, `emma`);
          // setup EmmaCIC
          const isPromotionChecked = yield select(getIsPromotionChecked);
          const sportsPADateCustKey = `EmmaSportsPA-${moment().format(
            'YYYYMMDD-HHmmss',
          )}`;
          if (isPromotionChecked) {
            // setup EmmaDM
            yield putCustState(
              'EmmaDM',
              JSON.stringify({
                DM2: 'Y',
              }),
              'emma',
            );
            // setup EmmaSportsPA
            yield putCustState(
              sportsPADateCustKey,
              JSON.stringify({
                DM2: 'Y',
              }),
              'emma',
            );
          }
          yield put(
            updateOffersFormResponse({
              title: 'OFFERS_COMFIRM_SUCCESS_TITLE',
              msg: 'OFFERS_COMFIRM_SUCCESS_MSG',
              buttonText: 'OFFERS_COMFIRM_SUCCESS_BUTTON_TEXT',
            }),
          );
          goto(`emma-free-offers-success`);
        } else {
          yield put(showErrorModal());
        }
      }
      yield put(updateReviewLoading(false));
    }
  } catch (error) {
    if (error && error.json) {
      // const errorMessage ={ code: 'XPAPI:MANDATORY_PROMOCODE_NOTVALID' }
      error.json().then(function (data: any) {
        const errorCode = _.get(data, 'code', '');
        if (PROMOTION_ERROR_CODE.includes(errorCode)) {
          store.dispatch({
            type: UPDATE_PROMOTION_ERROR_CODE,
            promotionErrorCode: errorCode,
          });
          action.callback && action.callback();
        }
      });
    } else {
      yield put(showErrorModal());
    }
    yield put(updateReviewLoading(false));
  }
}

function* toSubmitOffersLeadForm(action: any) {
  try {
    const url = yield select(getOffersFormSubmitApiApi);
    const token = select(getToken);
    const { submitOffersLeadFormData } = action;
    const { name, prefertime, title } = submitOffersLeadFormData;
    let message = t('OFFERS_SUBMIT_LEAD_FORM_SUCCESS_MSG');
    message = message.replace('${name}', name);
    message = message.replace('${time}', prefertime.toLowerCase());
    message = message.replace('${productName}', title ? title : '');
    switch (prefertime) {
      case t('MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_ANY_TIME'):
        submitOffersLeadFormData.prefertime = 'Any Time';
        break;
      case t('MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_IN_THE_MORNING'):
        submitOffersLeadFormData.prefertime = 'In the Morning';
        break;
      case t('MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_LUNCH_TIME'):
        submitOffersLeadFormData.prefertime = 'Lunch Time';
        break;
      case t('MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_IN_THE_AFTERNOON'):
        submitOffersLeadFormData.prefertime = 'In the Afternoon';
        break;
    }
    if (token) {
      const res = yield call(
        myAxaFetchWithToken,
        url,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(submitOffersLeadFormData),
        },
        undefined,
        undefined,
        0,
      );
      if (res && res.status === 200) {
        yield put(
          updateOffersFormResponse({
            productName: name,
            title: 'OFFERS_SUBMIT_LEAD_FORM_SUCCESS_TITLE',
            msg: message,
            buttonText: 'OFFERS_SUBMIT_LEAD_FORM_SUCCESS_BUTTON',
          }),
        );
        goto(`emma-free-offers-success`);
      } else {
        yield put(showErrorModal());
      }
    }
  } catch (e) {
    yield put(showErrorModal());
  }
}

// HKEMMA-99501: offers API decommission - depreciated in Emma1.5
// function* fetchOffers() {
//   const offerFeatures = yield select(getOffersFeatures);
//   if (offerFeatures.length > 0) return;

//   const offersFeatureUrl = yield select(getOffersFeatureUrl);
//   const fetchOffersSuccess = function* (serverConfig: {
//     retrieveOfferResponse: any;
//   }) {
//     const features =
//       serverConfig && serverConfig.retrieveOfferResponse
//         ? serverConfig.retrieveOfferResponse
//         : [];
//     const { data = [] } = filterBanner(
//       { retrieveBannerResponse: features },
//       null,
//       null,
//       'offers',
//     );
//     yield put({ type: FETCH_OFFERS_FEATURES_SUCCESS, featuresItems: data });
//     return Promise.resolve();
//   };
//   const fetchOffersFailure = function* (err: any) {
//     yield put({ type: FETCH_OFFERS_FEATURES_FAILURE, error: err });
//     return Promise.resolve();
//   };
//   yield startFetching(offersFeatureUrl, fetchOffersSuccess, fetchOffersFailure);
// }
// function* startFetching(
//   featureUrl: string,
//   fetchSuccess: any,
//   fetchFailure: any,
// ) {
//   const token = yield select(getToken);
//   const language = yield select(getLanguage);
//   if (!token || !featureUrl) {
//     return Promise.resolve();
//   } else {
//     const url = `${featureUrl}&language=${language.toUpperCase()}&device=WEB`;
//     try {
//       const res: any = yield call(myAxaFetchWithToken, url, {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json',
//           'x-axahk-msgid': uuidv4(),
//         },
//       });
//       const resData = yield res.json();
//       yield fetchSuccess(resData);
//     } catch (err) {
//       yield fetchFailure(err);
//     }
//   }
// }

function* offersSaga() {
  yield takeLatest(COMMIT_OFFERS_FORM, toCommitOffers);
  yield takeLatest(SUBMIT_OFFERS_LEAD_FORM, toSubmitOffersLeadForm);
  // HKEMMA-99501: offers API decommission - depreciated in Emma1.5
  // yield takeLatest(FETCH_OFFERS_FEATURES, fetchOffers);
  // yield fork(fetchOffers);
}

export default offersSaga;
